<div class="card">
    <div class="flex justify-content-center flex-wrap card-container blue-containe">
        <div
            class="flex align-items-center justify-content-center h-4rem bg-blue-500 font-bold text-white border-round m-2 p-4">
            You are not authorized to access this page, try to access next time.
        </div>
    </div>
</div>
